import { FC } from 'react';
import { Box, BoxProps, Heading, Text } from '@qga/roo-ui/components';
import { CUSTOMER_SUPPORT_HOTLINE_AU } from 'config/constants';
import TelLink from 'components/TelLink';

interface ContactUsWithReferenceProps extends BoxProps {
  caseNumber: string;
}

const ContactUsWithReference: FC<ContactUsWithReferenceProps> = ({ caseNumber, ...styleProp }) => (
  <Box {...styleProp}>
    <Heading.h3 fontSize="lg" mb={0}>
      Any more questions?
    </Heading.h3>
    <Box pt={[2, 3]}>
      <Text fontSize="lg" color="greys.charcoal">
        Please give us a call on <TelLink color="greys.charcoal" number={CUSTOMER_SUPPORT_HOTLINE_AU} /> and quote the request reference
        number {caseNumber}.
      </Text>
    </Box>
  </Box>
);

export default ContactUsWithReference;
